import { all, call, fork, put, takeLatest, select } from "redux-saga/effects";
import { Creators as ActionsAuditoria, Types } from "ducks/Auditoria";
import { Creators as ActionsGeral } from "ducks/Geral";
import { Creators as ActionsDashboard } from "ducks/Dashboard";
import api from "../api/api";
import notify from 'utils/modern_notify';

// eslint-disable-next-line no-unused-vars
let mensagem = "";

const getOcorrenciasRequisicao = async (dados) =>
    api
        .post(`api/auditoria/ocorrencias`, dados)
        .then((resposta) => resposta)
        .catch((error) => error);

const setStatusAuditoriaRequisicao = async (dados) =>
    api
        .put(`/api/auditoria/atualizar`, dados)
        .then((resposta) => resposta)
        .catch((error) => error);

const buscarNotasAuditoriaRequisicao = async (dados) =>
    api
        .post(`/api/auditoria/buscar`, dados)
        .then((resposta) => resposta)
        .catch((error) => error);

const getDash = (state) => (state.dashboard ? state.dashboard : {});

function* getOcorrencias({ payload }) {
    const { cnpjEmpresa, grupoEmpresa } = payload;
    // yield put(ActionsAuditoria.getOcorrenciasSucesso(ocorrencias));
    mensagem = "";
    try {
        const response = yield call(getOcorrenciasRequisicao, {
            cnpjEmpresa,
            grupoEmpresa,
        });
        if (response.ok) {
            yield put(
                ActionsAuditoria.getOcorrenciasSucesso(response.data.valor)
            );
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagem = `Ocorreu um erro ${response.data.error}`;
                        break;
                }
            } else {
                mensagem = "Ocorreu um erro interno.Tente novamente";
            }
            notify(mensagem)
        }
    } catch (error) {
        notify(`Error ao buscar ocorrências: ${error}`)
        // yield put(
        //     ActionsGeral.setMensagem({
        //         mensagem: `Error ao buscar ocorrências: ${error}`,
        //     })
        // );
    }
}

function* editarObsAuditoria({ payload }) {
    const { _id, cnpj, usuario, timezone, observacao } = payload;
    let dados = {
        _id,
        cnpj,
        usuario,
        observacao,
        timezone,
    };
    mensagem = "";
    try {
        const response = yield call(setStatusAuditoriaRequisicao, dados);
        if (response.ok) {
            notify("Status atualizado com sucesso !",2)
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                mensagem = "Ocorreu um erro interno.Tente novamente";
            }
            notify(mensagem)
        }
    } catch (error) {
        notify(`Error ao setar os status ${error}`)
    }
}

function* setStatusAuditoria({ payload }) {
    const {
        status,
        _id,
        cnpj,
        usuario,
        timezone,
        origem,
        ocorrencia,
        tipoAuditoria,
    } = payload;
    let dados = {};
    mensagem = "";
    if (!ocorrencia) {
        dados = {
            status,
            timezone,
            _id,
            cnpj,
            usuario,
            tipoAuditoria,
        };
    } else {
        dados = {
            status,
            timezone,
            _id,
            cnpj,
            usuario,
            ocorrencia,
            tipoAuditoria,
        };
    }
    try {
        const response = yield call(setStatusAuditoriaRequisicao, dados);
        if (response.ok) {
            switch (origem) {
                case "dash":
                    let dash = yield select(getDash);
                    yield put(
                        ActionsDashboard.setNotaSelecionada({
                            ...dash.notaSelecionada,
                            status,
                        })
                    );
                    break;
                case "auditoria":
                    break;
                default:
                    break;
            }
            notify("Status atualizado com sucesso !",2)
            yield put(ActionsAuditoria.removerNtsAuditoria(_id));
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                mensagem = "Ocorreu um erro interno.Tente novamente";
            }
            notify("Error ao setar os status.")
            return false;
        }
    } catch (error) {
        notify(`Error ao setar os status ${error}`)
    }
}

function* buscarNotasAuditoria({ payload }) {
    const { bases, grupo_emp } = payload;

    let dados = {
        grupo_emp,
        bases,
    };

    mensagem = "";
    try {
        const response = yield call(buscarNotasAuditoriaRequisicao, dados);
        if (response.ok) {
            if (response.data.status) {
                yield put(
                    ActionsAuditoria.buscarNotasAuditoriaSucesso({
                        dados: response.data.valor,
                    })
                );
            } else {
                notify("Error ao buscar dados auditoria.")
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                mensagem = "Ocorreu um erro interno.Tente novamente";
            }
            notify("Error ao buscar notas auditoria.")
        }
        yield put(ActionsAuditoria.setLoadAuditoria(false));
    } catch (error) {
        yield put(ActionsAuditoria.setLoadAuditoria(false));
        notify(`Error ao buscar notas auditoria ${error}`)
    }
}

export function* setStatusAuditoriaStatus() {
    yield takeLatest(Types.SET_STATUS_AUDITORIA, setStatusAuditoria);
}
export function* buscarDadosAuditoriaAcao() {
    yield takeLatest(Types.BUSCAR_NOTAS_AUDITORIA, buscarNotasAuditoria);
}
export function* editarObsAuditoriaAcao() {
    yield takeLatest(Types.EDITAR_OBS_AUDITORIA, editarObsAuditoria);
}
export function* getOcorrenciasAcao() {
    yield takeLatest(Types.GET_OCORRENCIAS, getOcorrencias);
}
export default function* rootSaga() {
    yield all([
        fork(setStatusAuditoriaStatus),
        fork(buscarDadosAuditoriaAcao),
        fork(editarObsAuditoriaAcao),
        fork(getOcorrenciasAcao),
    ]);
}
